import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { PROMO_PARTICIPATE_EUROCUP } from './endpointEurocopa';
import { IEsOnehubVWConfig } from '../../portal-service/models/es-one-hub-config';

export const participateEurocup = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
): Promise<Response> => {
	const endpoint = PROMO_PARTICIPATE_EUROCUP;

	const response = await authServiceInstance.post(esOnehubVWConfig.resourceHostId, endpoint);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};
